import type { owner_order_by } from '@vrplatform/graphql';

export const orderByOwner: owner_order_by = {
  name: 'asc_nulls_last',
};
